// extracted by mini-css-extract-plugin
export default {"l":"e70382939e"};